const inProd = process.env.NODE_ENV === "production";

export const config = {
  inProd,
  contracts: {
    USDC: {
      address:
        process.env.REACT_APP_USDC_ADDRESS ||
        "0x94a9D9AC8a22534E3FaCa9F4e7F2E2cf85d5E4C8", // USDC address
      decimals: 6,
    },
    USDT: {
      address:
        process.env.REACT_APP_USDT_ADDRESS ||
        "0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0", // USDT address
      decimals: 6,
    },
    Fees: {
      address:
        process.env.REACT_APP_FEES_ADDRESS ||
        "0x2E68d2F9e36f59fe427c56fE4749129de1A92430",
      decimals: 6,
    },
    USDCLendingManager: {
      address:
        process.env.REACT_APP_USDC_LENDING_MANAGER_ADDRESS ||
        "0xABD2a927Fe0797eb4aC35333CB6FBBBaE526B2bB", // USDC Lending Manager address
      decimals: 6,
    },
    USDTLendingManager: {
      address:
        process.env.REACT_APP_USDT_LENDING_MANAGER_ADDRESS ||
        "0x3b2ED0FF4E81706A4C90644B97d32E271666B585", // USDT Lending Manager address
      decimals: 6,
    },
    USDTUSDCBridgeManager: {
      address:
        process.env.REACT_APP_USDT_LENDING_MANAGER_ADDRESS ||
        "0xb1bff64020B8a1184329b5c221c4c1d206cfaE7b", // USDT Lending Manager address
      decimals: 6,
    },
  } as any,
  mixpanel: {
    token: process.env.REACT_APP_MP_TOKEN || "token",
  },
  labels: {
    brandName: process.env.REACT_APP_BRAND_NAME || "ProspectAI",
  },
  links: {
    blog: "https://substack.com/@prospectainewsletter",
  },
  typeform: {
    waitlistForm:
      process.env.REACT_APP_WAITLIST_FORM ||
      "https://f4q4dmiym0t.typeform.com/to/CNuyn2cA",
  },
  videos: {
    demoSource: "https://s3.us-east-1.amazonaws.com/prospectai.xyz/demo.mp4",
    demoPoster: "demo-poster.webp",
  },
};
